import { Outlet } from "react-router-dom";
import FrontendHeader from "../components/FrontendHeader";
import FrontendFooter from "../components/FrontendFooter";

// FrontendLayout.jsx
const FrontendLayout = () => (
  <>
    <main>
      <Outlet /> {/* Nested routes render here */}
    </main>
  </>
);

export default FrontendLayout;
